import { addressAnnotationSchema } from "../components/address-annotation";

export const addressSchema = {
  type: "object",
  properties: {
    aliases: {
      type: "array",
      items: {
        type: "string"
      }
    },
    accounts: {
      type: "array",
      items: {
        $ref: "#/definitions/addressAnnotationSchema"
      }
    },
    linkedAccounts: {
      type: "array",
      items: {
        type: "string"
      }
    },
    // claimed: {
    //   $ref: "/schemas/ByAtSchema",
    //   additionalProperties: false,
    //   properties: {
    //     accountId: {
    //       type: "string",
    //       pattern: "^[A-Za-z0-9_-]{22}$"
    //     },
    //     verified: {
    //       type: "boolean"
    //     }
    //   }
    // },
    edi: {
      type: "object",
      additionalProperties: true
    },
    validated: {
      type: "object",
      required: ["by", "isValidated"],
      properties: {
        by: {
          type: "string",
          enum: ["google", "bing", "here"]
        },
        confidence: {
          type: "string"
        },
        isValidated: {
          type: "boolean"
        }
      }
    },
    input: {
      type: "string"
    },
    street: {
      type: "string",
      maxLength: 100
    },
    number: {
      type: "string"
    },
    bus: {
      type: "string",
      default: ""
    },
    zip: {
      type: "string",
      minLength: 2
    },
    city: {
      type: "string",
      maxLength: 50
    },
    state: {
      type: "string",
      maxLength: 50
    },
    country: {
      type: "string"
    },
    countryCode: {
      type: "string",
      minLength: 2,
      maxLength: 2
    },
    timeZone: {
      type: "string"
    },
    location: {
      type: "object",
      properties: {
        lat: {
          type: "number"
        },
        lng: {
          type: "number"
        }
      }
    }
  },
  required: ["input", "country", "countryCode"],
  definitions: {
    addressAnnotationSchema
  }
};
